<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCheckSmall',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
